import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { PagedResult } from '../../../core/model/paged-result';
import { DataServiceBase } from '../../../core/service/base/data.service.base';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { LogRecord } from '../../model/log-record';

@Injectable()
export class SystemOwnerSettingsLogService extends DataServiceBase {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, messageService, progressBar, config, 'system-owner-settings-log');
  }

  getPagedList(page: number, pageSize: number): Observable<PagedResult<LogRecord>> {
    this.progressBar.start();
    return this.client
      .post<PagedResult<LogRecord>>(`${this.endpoint}/page`, {
        page,
        pageSize,
        filter: {},
      })
      .pipe(
        map(response => {
          const result = Object.assign(new PagedResult<LogRecord>(), response);
          result.items = response.items.map(item => new LogRecord(item));
          return result;
        }),
        finalize(() => this.progressBar.stop())
      );
  }
}
